import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      width: 265,
      padding: [56, 0, 36, 0],
      position: "relative",
      [theme.breakpoints.up("mobile")]: {
        width: 336.67,
      },
    },
    closeButton: {
      position: "absolute",
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(32),
    },
    closeBtnDesktopPosition: {
      right: 48,
      top: 32,
    },
    closeBtnMobilePosition: {
      right: 8,
      top: 8,
    },
    link: {
      display: "block",
      padding: [5, 36, 6],
      textAlign: "justify",
      color: alpha(theme.palette.primary.main, 0.6),
      fontSize: theme.typography.pxToRem(22),
      "&:hover": {
        backgroundColor: alpha(theme.palette.secondary.light, 0.25),
      },
      "& span": {
        position: "relative",
      },
    },
    linkActive: {
      color: theme.palette.primary.light,
      "& span::after": {
        content: "''",
        display: "block",
        width: 4,
        height: 4,
        borderRadius: 2,
        position: "absolute",
        right: -16,
        top: "calc(50% - 2px)",
        backgroundColor: theme.palette.primary.light,
      },
    },
    buttonLink: {
      display: "block",
      padding: [15, 36, 15],
      textAlign: "justify",
      "& span": {
        display: "inline-block",
        color: theme.palette.primary.light,
        border: [1, "solid", theme.palette.secondary.main],
        height: 38,
        lineHeight: theme.typography.pxToRem(38),
        fontSize: theme.typography.pxToRem(18),
        padding: [0, 24],
        borderRadius: 19,
      },
      "&:hover span": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    buttonLinkActive: {
      "& span": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    delimiter: {
      height: 3,
      background: "linear-gradient(180deg,#7DECED,#7DECED)",
      margin: [40, 36, 32],
    },
    logoLink: {
      margin: [42, 36, 0, 36],
      textAlign: "justify",
      display: "block",
    },
    logo: {
      width: 55,
    },
    sybPromoLink: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "justify",
      marginTop: 30,
    },
    sybLogo: {
      borderRadius: 10,
    },
  }),
  { name: "UserLayoutSideMenu" },
);
